import React, { useEffect, useState } from "react";
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Grid from '@mui/material/Grid';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import {
  Paper,
  Rating,
  Stack,
  Chip,
  TextField,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";



const Notice = ({ notice, setNotice, noticeObj, readNotice,checkSoftSmileModal }) => {


  const intl = useIntl();
  const navigate = useNavigate();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: noticeObj[0]?.title === "Feedback Form" ? "max-content" : 1000,
    bgcolor: "background.paper",
    outline: "none",
    boxShadow: 24,
    p: 4,
    borderRadius: noticeObj[0]?.title === "Feedback Form" ? 4 : 0,
    '@media (max-width:600px)': {
      width: "90%",  // mobilde 90%
    }
  };

  // PDF'leri Chromium'un yerleşik görüntüleyicisi yerine Google Docs Viewer ile aç.
  // Böylece sidebar (yer imleri/küçük resimler) paneli hiç gelmez ve kullanıcının
  // tarayıcıda kaldığı önceki sidebar durumu devreye girmez.
  const getIframeSrc = (url) => {
    if (!url) return url;
    const isPdf = /\.pdf(\?|#|$)/i.test(url);
    if (isPdf) {
      return `https://docs.google.com/viewer?url=${encodeURIComponent(url)}&embedded=true`;
    }
    return url;
  };

  const noticeTypes = [
    { type: "0", content: <Typography mt={2}> {metniBol(noticeObj[0]?.content)} </Typography> },
    { type: "1", content: <Grid mt={2}><iframe src={getIframeSrc(noticeObj[0]?.link)} width="800" height="600"></iframe></Grid> },
    { type: "2", content: <Grid mt={2}> <img width="100%" height="600px" src={noticeObj[0]?.link} /> </Grid> },
    { type: "3", content: <Grid mt={2}> <iframe src={getIframeSrc(noticeObj[0]?.link)} width="800" height="600"></iframe> </Grid> }
  ];

  const noticeContent = popupType => noticeTypes.find(i => i.type === popupType).content;

  function metniBol(metin) {
    return metin.split('/n').map((parca, i) => (
      <React.Fragment key={i}>
        {parca}
        {i !== metin.split('/n').length - 1 && <br />}
      </React.Fragment>
    ));
  }



  const [rating, setRating] = useState(0);
  const [processes, setProcesses] = useState([]);
  const [reason, setReason] = useState("");
  const [featureRequest, setFeatureRequest] = useState("");
  const [loading, setLoading] = useState(false);

  const [ratingError, setRatingError] = useState(false);
  const [processError, setProcessError] = useState(false);
  const [reasonError, setReasonError] = useState(false);

  const improvementOptions = [
    { value: "Analiz Sureci", labelIntlId: "feedback.process.analysis" },
    { value: "Uretim Sureci", labelIntlId: "feedback.process.production" },
    { value: "Satis Sureci", labelIntlId: "feedback.process.sales" },
    { value: "Hicbir gelistirmeye ihtiyac duymuyorum", labelIntlId: "feedback.process.none" },
    { value: "Diger", labelIntlId: "feedback.process.other" }
  ];


  const toggleProcess = (val) => {
    setProcesses((prev) => {
      const next = prev.includes(val)
        ? prev.filter((p) => p !== val)
        : [...prev, val];

      if (!next.includes("Diger")) {
        setReason("");
        setReasonError(false);
      }

      return next;
    });
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    let hasError = false;

    if (rating === 0) {
      setRatingError(true);
      hasError = true;
    } else {
      setRatingError(false);
    }

    if (processes.length === 0) {
      setProcessError(true);
      hasError = true;
    } else {
      setProcessError(false);
    }

    if (processes.includes("Diger") && reason.trim() === "") {
      setReasonError(true);
      hasError = true;
    } else {
      setReasonError(false);
    }

    if (hasError) {
      setLoading(false);
      return;
    }

    const userData = JSON.parse(localStorage.getItem('userData'));
    try {
      const res = await fetch(
        "https://script.google.com/macros/s/AKfycbxoD_OST21U8JySBFbB2JrbZBMelVKLy6CYIVSDDOzQJTwfCAasRoqNUjAfpmZBv-YZFQ/exec",
        {
          method: "POST",
          mode: "cors",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: (`Name=${encodeURIComponent(userData?.first_name + ' ' + userData?.last_name)}&Email=${encodeURIComponent(userData?.email)}&Country=${userData?.country}&Rating=${rating.toString()}&Development=${processes}&DevelopmentExtraNote=${encodeURIComponent(reason)}&Extra=${encodeURIComponent(featureRequest)}`),
        }
      );



      setRating(0);
      setProcesses([]);
      setReason("");
      setFeatureRequest("");
      await readNotice();
      setNotice(false);
      alert(intl.formatMessage({ id: "feedback.alert.success" }));
      checkSoftSmileModal()
    } catch (err) {
      alert(intl.formatMessage({ id: "feedback.alert.error" }));
      setNotice(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (processes.length > 0) {
      setProcessError(false);
    }
  }, [processes]);

  return (
    <Modal open={notice} onClose={() => {setNotice(false);sessionStorage.setItem("popupState", "true");checkSoftSmileModal()}} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" >
      <Box sx={style}>
        <Grid mt={2} align="center">
          {noticeObj[0]?.title === "Feedback Form"
            ?
            <Paper
              elevation={3}
              sx={{
                width: "100%",
                maxWidth: 650,
                mx: "auto",
                borderRadius: 4,
                textAlign: "left",
                    boxShadow:"0"
              }}
            >
              {/* Header */}
              <Typography variant="h4" fontWeight={700} mb={3}>
                <FormattedMessage id="feedback.title" />
              </Typography>

              {/* Rating */}
              <Box mb={4}>
                <Typography variant="h5" fontWeight={500} mb={1}>
                  <FormattedMessage id="feedback.rating.question" />
                </Typography>

                <Rating
                  value={rating}
                  onChange={(e, v) => {
                    setRating(v);
                    setRatingError(false);
                  }}
                  size="large"
                  sx={{
                    color: "#FFB800",
                    "& .MuiRating-iconEmpty": { color: "#E0E0E0" },

                    "& .MuiRating-icon": {
                      marginRight: "6px",
                    },
                    "& .MuiRating-icon:last-of-type": {
                      marginRight: 0,
                    },
                  }}
                />
                {ratingError && (
                  <Typography color="error" variant="caption" sx={{ mt: 0.5, display: "block" }}>
                    <FormattedMessage id="feedback.validation.ratingRequired" />
                  </Typography>
                )}
                <Typography variant="body2" color="text.secondary" mt={1}>
                  1: <FormattedMessage id="feedback.rating.option.veryHard" /> — 5: <FormattedMessage id="feedback.rating.option.veryEasy" />
                </Typography>
              </Box>

              {/* Processes */}
              <Box mb={4}>
                <Typography variant="h5" fontWeight={500} mb={1.5}>
                  <FormattedMessage id="feedback.processes.question" />
                </Typography>

                <Box display={"flex"} direction="row" gap={1.5} flexWrap="wrap" justifyContent={"flex-start"}>
                  {improvementOptions.map((opt) => {
                    const selected = processes.includes(opt.value);
                    return (
                      <Box
                        key={opt.value}
                        onClick={() => {
                          toggleProcess(opt.value);
                        }}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 0.7,
                          px: 1.2,
                          py: 1,
                          borderRadius: "12px",
                          cursor: "pointer",
                          border: "1px solid",
                          borderColor: selected ? "#8B3DFF" : "#D1D5DB",
                          bgcolor: selected ? "rgba(139,61,255,0.10)" : "transparent",
                          "&:hover": {
                            borderColor: "#8B3DFF",
                            bgcolor: "rgba(139,61,255,0.07)",
                          },
                        }}
                      >
                        {/* Checkbox Icon */}
                        <Box
                          sx={{
                            width: 16,
                            height: 16,
                            borderRadius: "4px",
                            border: "2px solid",
                            borderColor: selected ? "#8B3DFF" : "#94A3B8",
                            backgroundColor: selected ? "#8B3DFF" : "transparent",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            transition: "all 0.15s ease-in-out"
                          }}
                        >
                          {selected && (
                            <CheckIcon
                              sx={{
                                fontSize: 14,
                                color: "white"
                              }}
                            />
                          )}
                        </Box>

                        {/* Label */}
                        <Typography sx={{ fontSize: "0.75rem", color: "#374151" }}>
                          <FormattedMessage id={opt.labelIntlId} />
                        </Typography>
                      </Box>

                    );
                  })}


                </Box>
                {processError && (
                  <Typography
                    color="error"
                    variant="caption"
                    sx={{ mt: 1, display: "block" }}
                  >
                    <FormattedMessage id="feedback.validation.processRequired" />
                  </Typography>
                )}
                {processes.includes("Diger") && (
                  <TextField
                    fullWidth
                    size="small"
                    placeholder={intl.formatMessage({ id: "feedback.reason.other.placeholder" })}
                    value={reason}
                    onChange={(e) => {
                      setReason(e.target.value);
                      setReasonError(false);
                    }}
                    sx={{
                      mt: 2,
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "12px",
                      },
                    }}
                    error={reasonError}
                    helperText={
                      reasonError ? (
                        <FormattedMessage id="feedback.validation.otherReasonRequired" />
                      ) : ""
                    }
                  />
                )}
              </Box>

              {/* Feature Request */}
              <Box mb={4}>
                <Typography variant="h5" fontWeight={500} mb={1.5}>
                  <FormattedMessage id="feedback.feature.question" />
                </Typography>

                <TextField
                  fullWidth
                  multiline
                  rows={4}
                  placeholder={intl.formatMessage({ id: "feedback.feature.placeholder" })}
                  value={featureRequest}
                  onChange={(e) => setFeatureRequest(e.target.value)}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "12px",
                    },
                  }}
                />
              </Box>

              {/* Footer */}
              <Stack direction="row" justifyContent="flex-end" mt={4}>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#8B3DFF",
                    fontWeight: 600,
                    px: 4,
                    "&:hover": { backgroundColor: "#7A2EEB" },
                    borderRadius: "10px",
                  }}
                  disabled={loading}
                  onClick={handleSubmit}
                >
                  {loading ? <FormattedMessage id="feedback.sending" /> : <FormattedMessage id="feedback.submit" />}
                </Button>
              </Stack>
            </Paper>
            :
            noticeObj[0]?.title.toLowerCase().includes("webinar")
              ?
              <>
                <Typography textAlign="center" fontSize="18px" color="#663BB9" marginBottom={1}> {noticeObj[0]?.title} </Typography>
                <a target="_blank" href="https://us06web.zoom.us/j/81690589990?pwd=bwMdniw8c35obAuZcPJKLMwotakwDQ.1">
                    <img src={noticeObj[0]?.link } alt="meet_image"/>
                </a>
                {noticeObj[0]?.typePopup !== "2" && noticeContent(noticeObj[0]?.typePopup)}
              </>
              :
              <>
                <Typography textAlign="center" fontSize="18px" color="#663BB9"> {noticeObj[0]?.title} </Typography>
                {noticeObj[0]?.typePopup !== "0" && noticeObj[0]?.content && <Typography mt={2}> {metniBol(noticeObj[0]?.content)} </Typography>}
                {noticeContent(noticeObj[0]?.typePopup)}
              </>
          }

        </Grid>
        {noticeObj[0]?.title !== "Feedback Form" && (

          <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
            {noticeObj[0]?.title.toLowerCase().includes("klinik tercihlerinize") && (
              <Button
                variant="contained"
                onClick={() => {
                  navigate('/clinical');
                  readNotice();
                }}
              >
                <FormattedMessage id="Klinik Tercihlerine Git" />
              </Button>
            )}
            <Button variant="contained" onClick={readNotice}><FormattedMessage id="Read" /></Button>
          </Box>
        )}
      </Box>
    </Modal>
  );
};

export default Notice;
